"use client";

import React from "react";
import { BookOpen, Network, Users } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const capabilities = [{
  title: "PROFIL & SEJARAH",
  description: "Profil, sejarah, visi-misi, lambang, atribut dan dokumen dasar organisasi.",
  icon: BookOpen,
  link: "/ProfileConstitutionPage"
}, {
  title: "STRUKTUR & HIERARKI",
  description: "Lihat struktur organisasi dari MPN, MPW, MPC, PAC, Ranting hingga Anak Ranting.",
  icon: Network,
  link: "/OrganizationStructurePage"
}, {
  title: "BADAN, LEMBAGA & SAYAP",
  description: "Informasi badan, lembaga dan sayap organisasi di tingkat nasional dan wilayah.",
  icon: Users,
  link: "/UnitAndBodyPage"
}];
export default function Capabilities() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="zonappcapabilities" className="bg-background py-12 md:py-16 lg:py-20">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {capabilities.map((item, i) => {
          const Icon = item.icon;
          return <Card key={i} data-index={i} className="flex flex-col items-center border border-border text-center shadow-sm hover:shadow-md transition-shadow">
                <CardContent className="flex flex-grow flex-col items-center pt-8">
                  <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-lg bg-primary/10 text-primary">
                    <Icon className="h-8 w-8" strokeWidth={1.5} />
                  </div>
                  <h3 className="mb-3 font-default text-base font-bold text-primary uppercase tracking-wide">
                    {item.title}
                  </h3>
                  <p className="mb-6 text-sm font-default text-foreground/70 leading-relaxed flex-grow">
                    {item.description}
                  </p>
                  <Link to={item.link} className="text-primary font-default font-semibold text-sm hover:text-primary/80 transition-colors">
                    Lihat Selengkapnya
                  </Link>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}